<template>
	<ULink>
		<slot />
	</ULink>
</template>
